export default __webpack_public_path__ + "static/story-start@2x-9fa2545fc38e99bcb35a4f2f640f8542.png";